export default function CustomCheckbox({ checked, onChange, disabled = false, indeterminate = false }) {
  return (
    <label className="inline-flex items-center cursor-pointer select-none px-2 py-1">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="peer hidden"
      />
      <div
        className={`
          w-4 h-4 border-2 rounded-sm flex items-center justify-center
          transition-colors duration-200 ease-in-out
          ${indeterminate
            ? 'bg-yellow-400 border-yellow-400 after:content-["−"] after:text-white'
            : ''}
          peer-checked:bg-blue-600 peer-checked:border-blue-600
          peer-checked:after:content-['✔'] peer-checked:after:text-white
          peer-checked:after:text-xs peer-checked:after:font-semibold
          peer-disabled:opacity-50
          border-gray-300 hover:border-blue-500
        `}
      />
    </label>
  );
}
